import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { SiteDetailAlertService } from '../site-detail-alert/site-detail-alert.service';

@Component({
  selector: 'app-site-detail-alert-wbgt',
  templateUrl: './site-detail-alert-wbgt.component.html',
  styleUrls: ['./site-detail-alert-wbgt.component.scss'],
})
export class SiteDetailAlertWbgtComponent implements OnChanges {
  @Input() date: string = '';

  isOuter = false; // 外部のユーザかどうか

  constructor(private siteDetailAlertService: SiteDetailAlertService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.isOuter = this.siteDetailAlertService.isOuterUser();
  }
}
